<script>
/**
 * Mixin for picking a display config preset for indicator charts
 * Same behaviour as ./problems.vue.
 */

import { uniq } from 'lodash';
// Vuex
import { mapState } from 'vuex';
import { FETCH_INDICATOR_DISPLAY_CONFIGS, FETCH_INDICATOR_THEMES } from '@/store/action-types';
import { GET_INDICATOR_DISPLAY_CONFIGS, GET_INDICATOR_THEMES } from '@/store/mutation-types';

export default {

  data() {
    return {
      doFetchIndicatorsInMixin: true,
    };
  },

  computed: {
    idcOptions() {
      return [
        // WARNING: Changing the key of this option can break the behavior of 'dashboardOptExcludeIdcOptions'
        {
          key: 'defaultPresetId',
          value: this.idcOptPresetId,
          component: 'IndicatorDisplayConfigField',
          options: {
            class: 'mt3em',
            detailedIndicatorHint: true,
            legend: `${this.$t('message.IDC_CHART')}${this.$t('message.TWO_DOTS')}`,
          },
        },
        // WARNING: Changing the key of this option can break the behavior of 'dashboardOptExcludeIdcOptions'
        {
          key: 'idcOptPresetIdHint',
          value: '',
          component: 'Div',
          options: {
            class: 'mb5 field-hint',
          },
          slots: [{
            component: 'Div',
            content: this.$t('help.INDICS_PERIOD_PRESETS'),
          }],
        },
        {
          key: 'idcOptSep1',
          value: '',
          component: 'Div',
          options: { class: 'filters-zone__modal__sep' },
        },
        {
          key: 'hiddenIndicators',
          component: 'HideIndicatorsOptionsField',
          value: this.idcOptHiddenIndicators,
          options: {
            themes: this.idcOptClassicThemes,
            class: 'mt10em',
          },
        },
        {
          key: 'idcOptHiddenIndicatorsHint',
          value: '',
          component: 'Div',
          options: {
            class: 'mb5 field-hint',
          },
          slots: [{
            component: 'Div',
            content: this.$t('message.HIDE_INDICATORS_HINT'),
          }],
        },
      ];
    },
    idcOptPresetId() {
      if (this.allPageOptions && !isNaN(this.allPageOptions.defaultPresetId)) {
        return this.allPageOptions.defaultPresetId;
      }
      return 1;
    },
    idcOptHiddenIndicators() {
      if (this.allPageOptions && this.allPageOptions.hiddenIndicators instanceof Array) {
        return uniq([...this.allPageOptions.hiddenIndicators, ...this.idcOptGwIndicIds]);
      }
      return this.idcOptGwIndicIds;
    },
    /** Array: All themes excluding GW themes and their indicators */
    idcOptClassicThemes() {
      return this.idcOptThemes.filter(theme => !theme.indicators.some(i => Number(i.isGw) === 1));
    },
    /** Array: IDs of GW indicators */
    idcOptGwIndicIds() {
      return this.idcOptThemes
        .flatMap(theme => theme.indicators
          .filter(({ isGw }) => isGw === 1)
          .map(indic => indic.id));
    },
    // Custom indicator display configs
    ...mapState({
      idcOptConfigs: state => state[GET_INDICATOR_DISPLAY_CONFIGS.stateKey] || [],
      idcOptConfigsLoading: state => state[GET_INDICATOR_DISPLAY_CONFIGS.loadingKey],
      idcOptThemes: state => state[GET_INDICATOR_THEMES.stateKey] || [],
      idcOptThemesLoading: state => state[GET_INDICATOR_THEMES.loadingKey],
      currentTeam: state => state.currentTeam,
    }),
  },
  created() {
    // Fetch all display configs
    if (!this.idcOptConfigsLoading && this.currentTeam && this.currentTeam.id) {
      this.$store.dispatch(FETCH_INDICATOR_DISPLAY_CONFIGS);
    }
    // Fetch all indicators
    if (this.doFetchIndicatorsInMixin && !this.idcOptThemesLoading && this.currentTeam && this.currentTeam.id) {
      this.$store.dispatch(FETCH_INDICATOR_THEMES);
    }
  },
  methods: {
    idcOptQueryParams(options) {
      if (!options) {
        return '';
      }
      let query = '';
      let amp = '';
      if (options.defaultPresetId !== undefined) {
        query += `${amp}defaultPresetId=${options.defaultPresetId}`;
        amp = '&';
      }
      if (options.hiddenIndicators) {
        query += `${amp}hiddenIndicators=${options.hiddenIndicators.join(',')}`;
        amp = '&';
      }
      return query;
    },
    idcOptUserLoaded() {
      if (!this.idcOptConfigsLoading) {
        this.$store.dispatch(FETCH_INDICATOR_DISPLAY_CONFIGS);
      }
      if (!this.idcOptThemesLoading) {
        this.$store.dispatch(FETCH_INDICATOR_THEMES);
      }
    },
  },
};
</script>
